export default function (element) {
  return element?.scrollHeight > element?.clientHeight;
}
